import { useTranslation } from 'react-i18next'
import { useField } from 'formik'

import { Field } from '../../../../Field'
import { ListAttachedTags } from '../../../../List'
import { RequestAttachTag } from '../../../../Request'
import { NEWSBOARD_POST_FORM_FIELD_REQUESTS } from '../../NewsboardPostForm.constants'

function AttachedServiceRequests({ disabled, onRemoveAttachedRequest }) {
  const { t } = useTranslation()
  const [field] = useField(NEWSBOARD_POST_FORM_FIELD_REQUESTS)

  return (
    <Field
      disabled={disabled}
      label={`${t('Newsboard.AttachedRequestsLabelKey')}:`}
    >
      <ListAttachedTags
        Tag={RequestAttachTag}
        items={field.value}
        tagProps={{
          disabled,
          onDelete: onRemoveAttachedRequest,
        }}
      />
    </Field>
  )
}

export default AttachedServiceRequests
